import React from 'react';

const Benefits = () => (
	<div className="container main">
		<h2>혜택</h2>
		<hr/>
		<div className="row">
			<div className="col-sm-12">
				<h4>OECD <em>GlobalRecalls</em> 포털을 사용하면 어떤 이점이 있습니까?</h4>
				<p>
					<strong>정부 기관</strong>의 경우, 포털은 중앙 집중식으로 적시에 전 세계적으로 제품 리콜 정보 공유를 강화하여 많은 이점을 제공합니다.
					정부 기관은 특히 대화형 <a href="https://globalrecalls.oecd.org/#/dashboard?lang=ko">대시보드</a>를 통해 새로운 추세를 추적하고 관할 지역의 소비자에 영향을 미치는 위험 요소를 찾아서 조치를 취할 수 있습니다.
					제조 공급망이 세계화되고 온라인 해외 쇼핑이 증가하면서 안전 문제 발생 시 여러 관할권에서 제품 리콜을 요구할 수 있게 되었습니다.
				</p>
				<p>
					포털은 공통 제품 분류 체계를 사용하며 여러 정부 당국의 자국 리콜 데이터베이스와 쉽게 연결됩니다.
					<a href="https://globalrecalls.oecd.org/#/admin?lang=ko">수출 API</a>는 정부뿐만 아니라 포털의 데이터를 자세히 살펴보려는 일반 대중도 누구나 사용할 수 있습니다.
				</p>
				<p>
					<strong>기업</strong>, 특히 제품 <strong>제조업체</strong>인 경우, 포털에서 제공하는 정보를 활용하여 더욱 신속하게 안전 문제 해결에 나설 수 있으므로, 상해 유발 사고 건수를 줄여 관련 비용을 절감할 수 있습니다.
					<strong>해외에서 소비재를 수입하는 기업은 다른 관할권의 제품 리콜 상태를 확인하여 혜택을 받을 수도 있습니다.</strong>
					<strong>소매업체와 온라인 마켓플레이</strong>스는 포털을 참고하여 안전하지 않은 제품을 판매하지 않도록 더욱 신속하게 조치를 취할 수 있습니다.
				</p>
				<p>제품 비교에 관심이 있는 소<strong>비자</strong>들은 포털의 모바일용 웹사이트에서 언제든지 쉽게 제품의 리콜 상태를 확인할 수 있습니다.</p>
			</div>
		</div>
	</div>
);

export default Benefits;



// WEBPACK FOOTER //
// ./src/views/static/ko/benefits.js